import { z } from 'zod';

export type CurrencyCodesAll = keyof typeof ALL_CURRENCIES;
export type CurrencyCodes = keyof typeof SUPPORTED_CURRENCIES;

/**
 * Sourced from https://en.wikipedia.org/wiki/List_of_circulating_currencies
 */
export const ALL_CURRENCIES = {
  AED: { name: 'United Arab Emirates dirham', code: 'AED' },
  AFN: { name: 'Afghan afghani', code: 'AFN' },
  ALL: { name: 'Albanian lek', code: 'ALL' },
  AMD: { name: 'Armenian dram', code: 'AMD' },
  ANG: { name: 'Netherlands Antillean guilder', code: 'ANG' },
  AOA: { name: 'Angolan kwanza', code: 'AOA' },
  ARS: { name: 'Argentine peso', code: 'ARS' },
  AUD: { name: 'Australian dollar', code: 'AUD' },
  AWG: { name: 'Aruban florin', code: 'AWG' },
  AZN: { name: 'Azerbaijani manat', code: 'AZN' },
  BAM: { name: 'Bosnia and Herzegovina convertible mark', code: 'BAM' },
  BBD: { name: 'Barbadian dollar', code: 'BBD' },
  BDT: { name: 'Bangladeshi taka', code: 'BDT' },
  BGN: { name: 'Bulgarian lev', code: 'BGN' },
  BHD: { name: 'Bahraini dinar', code: 'BHD' },
  BIF: { name: 'Burundian franc', code: 'BIF' },
  BMD: { name: 'Bermudian dollar', code: 'BMD' },
  BND: { name: 'Brunei dollar', code: 'BND' },
  BOB: { name: 'Bolivian boliviano', code: 'BOB' },
  BRL: { name: 'Brazilian real', code: 'BRL' },
  BSD: { name: 'Bahamian dollar', code: 'BSD' },
  BTN: { name: 'Bhutanese ngultrum', code: 'BTN' },
  BWP: { name: 'Botswana pula', code: 'BWP' },
  BYN: { name: 'Belarusian ruble', code: 'BYN' },
  BZD: { name: 'Belize dollar', code: 'BZD' },
  CAD: { name: 'Canadian dollar', code: 'CAD' },
  CDF: { name: 'Congolese franc', code: 'CDF' },
  CHF: { name: 'Swiss franc', code: 'CHF' },
  CLP: { name: 'Chilean peso', code: 'CLP' },
  CNY: { name: 'Renminbi', code: 'CNY' },
  COP: { name: 'Colombian peso', code: 'COP' },
  CRC: { name: 'Costa Rican colón', code: 'CRC' },
  CUP: { name: 'Cuban peso', code: 'CUP' },
  CVE: { name: 'Cape Verdean escudo', code: 'CVE' },
  CZK: { name: 'Czech koruna', code: 'CZK' },
  DJF: { name: 'Djiboutian franc', code: 'DJF' },
  DKK: { name: 'Danish krone', code: 'DKK' },
  DOP: { name: 'Dominican peso', code: 'DOP' },
  DZD: { name: 'Algerian dinar', code: 'DZD' },
  EGP: { name: 'Egyptian pound', code: 'EGP' },
  ERN: { name: 'Eritrean nakfa', code: 'ERN' },
  ETB: { name: 'Ethiopian birr', code: 'ETB' },
  EUR: { name: 'Euro', code: 'EUR' },
  FJD: { name: 'Fijian dollar', code: 'FJD' },
  FKP: { name: 'Falkland Islands pound', code: 'FKP' },
  GBP: { name: 'Sterling', code: 'GBP' },
  GEL: { name: 'Georgian lari', code: 'GEL' },
  GHS: { name: 'Ghanaian cedi', code: 'GHS' },
  GIP: { name: 'Gibraltar pound', code: 'GIP' },
  GMD: { name: 'Gambian dalasi', code: 'GMD' },
  GNF: { name: 'Guinean franc', code: 'GNF' },
  GTQ: { name: 'Guatemalan quetzal', code: 'GTQ' },
  GYD: { name: 'Guyanese dollar', code: 'GYD' },
  HKD: { name: 'Hong Kong dollar', code: 'HKD' },
  HNL: { name: 'Honduran lempira', code: 'HNL' },
  HTG: { name: 'Haitian gourde', code: 'HTG' },
  HUF: { name: 'Hungarian forint', code: 'HUF' },
  IDR: { name: 'Indonesian rupiah', code: 'IDR' },
  ILS: { name: 'Israeli new shekel', code: 'ILS' },
  INR: { name: 'Indian rupee', code: 'INR' },
  IQD: { name: 'Iraqi dinar', code: 'IQD' },
  IRR: { name: 'Iranian rial', code: 'IRR' },
  ISK: { name: 'Icelandic króna', code: 'ISK' },
  JMD: { name: 'Jamaican dollar', code: 'JMD' },
  JOD: { name: 'Jordanian dinar', code: 'JOD' },
  JPY: { name: 'Japanese yen', code: 'JPY' },
  KES: { name: 'Kenyan shilling', code: 'KES' },
  KGS: { name: 'Kyrgyz som', code: 'KGS' },
  KHR: { name: 'Cambodian riel', code: 'KHR' },
  KMF: { name: 'Comorian franc', code: 'KMF' },
  KPW: { name: 'North Korean won', code: 'KPW' },
  KRW: { name: 'South Korean won', code: 'KRW' },
  KWD: { name: 'Kuwaiti dinar', code: 'KWD' },
  KYD: { name: 'Cayman Islands dollar', code: 'KYD' },
  KZT: { name: 'Kazakhstani tenge', code: 'KZT' },
  LAK: { name: 'Lao kip', code: 'LAK' },
  LBP: { name: 'Lebanese pound', code: 'LBP' },
  LKR: { name: 'Sri Lankan rupee', code: 'LKR' },
  LRD: { name: 'Liberian dollar', code: 'LRD' },
  LSL: { name: 'Lesotho loti', code: 'LSL' },
  LYD: { name: 'Libyan dinar', code: 'LYD' },
  MAD: { name: 'Moroccan dirham', code: 'MAD' },
  MDL: { name: 'Moldovan leu', code: 'MDL' },
  MGA: { name: 'Malagasy ariary', code: 'MGA' },
  MKD: { name: 'Macedonian denar', code: 'MKD' },
  MMK: { name: 'Burmese kyat', code: 'MMK' },
  MNT: { name: 'Mongolian tögrög', code: 'MNT' },
  MOP: { name: 'Macanese pataca', code: 'MOP' },
  MRU: { name: 'Mauritanian ouguiya', code: 'MRU' },
  MUR: { name: 'Mauritian rupee', code: 'MUR' },
  MVR: { name: 'Maldivian rufiyaa', code: 'MVR' },
  MWK: { name: 'Malawian kwacha', code: 'MWK' },
  MXN: { name: 'Mexican peso', code: 'MXN' },
  MYR: { name: 'Malaysian ringgit', code: 'MYR' },
  MZN: { name: 'Mozambican metical', code: 'MZN' },
  NAD: { name: 'Namibian dollar', code: 'NAD' },
  NGN: { name: 'Nigerian naira', code: 'NGN' },
  NIO: { name: 'Nicaraguan córdoba', code: 'NIO' },
  NOK: { name: 'Norwegian krone', code: 'NOK' },
  NPR: { name: 'Nepalese rupee', code: 'NPR' },
  NZD: { name: 'New Zealand dollar', code: 'NZD' },
  OMR: { name: 'Omani rial', code: 'OMR' },
  PAB: { name: 'Panamanian balboa', code: 'PAB' },
  PEN: { name: 'Peruvian sol', code: 'PEN' },
  PGK: { name: 'Papua New Guinean kina', code: 'PGK' },
  PHP: { name: 'Philippine peso', code: 'PHP' },
  PKR: { name: 'Pakistani rupee', code: 'PKR' },
  PLN: { name: 'Polish złoty', code: 'PLN' },
  PYG: { name: 'Paraguayan guaraní', code: 'PYG' },
  QAR: { name: 'Qatari riyal', code: 'QAR' },
  RON: { name: 'Romanian leu', code: 'RON' },
  RSD: { name: 'Serbian dinar', code: 'RSD' },
  RUB: { name: 'Russian ruble', code: 'RUB' },
  RWF: { name: 'Rwandan franc', code: 'RWF' },
  SAR: { name: 'Saudi riyal', code: 'SAR' },
  SBD: { name: 'Solomon Islands dollar', code: 'SBD' },
  SCR: { name: 'Seychellois rupee', code: 'SCR' },
  SDG: { name: 'Sudanese pound', code: 'SDG' },
  SEK: { name: 'Swedish krona', code: 'SEK' },
  SGD: { name: 'Singapore dollar', code: 'SGD' },
  SHP: { name: 'Saint Helena pound', code: 'SHP' },
  SLE: { name: 'Sierra Leonean leone', code: 'SLE' },
  SOS: { name: 'Somali shilling', code: 'SOS' },
  SRD: { name: 'Surinamese dollar', code: 'SRD' },
  SSP: { name: 'South Sudanese pound', code: 'SSP' },
  STN: { name: 'São Tomé and Príncipe dobra', code: 'STN' },
  SYP: { name: 'Syrian pound', code: 'SYP' },
  SZL: { name: 'Swazi lilangeni', code: 'SZL' },
  THB: { name: 'Thai baht', code: 'THB' },
  TJS: { name: 'Tajikistani somoni', code: 'TJS' },
  TMT: { name: 'Turkmenistani manat', code: 'TMT' },
  TND: { name: 'Tunisian dinar', code: 'TND' },
  TOP: { name: "Tongan pa'anga", code: 'TOP' },
  TRY: { name: 'Turkish lira', code: 'TRY' },
  TTD: { name: 'Trinidad and Tobago dollar', code: 'TTD' },
  TWD: { name: 'New Taiwan dollar', code: 'TWD' },
  TZS: { name: 'Tanzanian shilling', code: 'TZS' },
  UAH: { name: 'Ukrainian hryvnia', code: 'UAH' },
  UGX: { name: 'Ugandan shilling', code: 'UGX' },
  USD: { name: 'United States dollar', code: 'USD' },
  UYU: { name: 'Uruguayan peso', code: 'UYU' },
  UZS: { name: 'Uzbekistani sum', code: 'UZS' },
  VED: { name: 'Venezuelan digital bolívar', code: 'VED' },
  VES: { name: 'Venezuelan sovereign bolívar', code: 'VES' },
  VND: { name: 'Vietnamese đồng', code: 'VND' },
  VUV: { name: 'Vanuatu vatu', code: 'VUV' },
  WST: { name: 'Samoan tālā', code: 'WST' },
  XAF: { name: 'Central African CFA franc', code: 'XAF' },
  XCD: { name: 'Eastern Caribbean dollar', code: 'XCD' },
  XOF: { name: 'West African CFA franc', code: 'XOF' },
  XPF: { name: 'CFP franc', code: 'XPF' },
  YER: { name: 'Yemeni rial', code: 'YER' },
  ZAR: { name: 'South African rand', code: 'ZAR' },
  ZMW: { name: 'Zambian kwacha', code: 'ZMW' },
} as const;

// FIXME: Backend API should provide list of available currencies
export const SUPPORTED_CURRENCIES = {
  AED: ALL_CURRENCIES.AED,
  AUD: ALL_CURRENCIES.AUD,
  BAM: ALL_CURRENCIES.BAM,
  BGN: ALL_CURRENCIES.BGN,
  BRL: ALL_CURRENCIES.BRL,
  BYN: ALL_CURRENCIES.BYN,
  CAD: ALL_CURRENCIES.CAD,
  CHF: ALL_CURRENCIES.CHF,
  CLP: ALL_CURRENCIES.CLP,
  COP: ALL_CURRENCIES.COP,
  CZK: ALL_CURRENCIES.CZK,
  CNY: ALL_CURRENCIES.CNY,
  DKK: ALL_CURRENCIES.DKK,
  EUR: ALL_CURRENCIES.EUR,
  GBP: ALL_CURRENCIES.GBP,
  HUF: ALL_CURRENCIES.HUF,
  IDR: ALL_CURRENCIES.IDR,
  INR: ALL_CURRENCIES.INR,
  ISK: ALL_CURRENCIES.ISK,
  JPY: ALL_CURRENCIES.JPY,
  MXN: ALL_CURRENCIES.MXN,
  MYR: ALL_CURRENCIES.MYR,
  NOK: ALL_CURRENCIES.NOK,
  NZD: ALL_CURRENCIES.NZD,
  PLN: ALL_CURRENCIES.PLN,
  RON: ALL_CURRENCIES.RON,
  RSD: ALL_CURRENCIES.RSD,
  SEK: ALL_CURRENCIES.SEK,
  SGD: ALL_CURRENCIES.SGD,
  TWD: ALL_CURRENCIES.TWD,
  USD: ALL_CURRENCIES.USD,
  UAH: ALL_CURRENCIES.UAH,
  ZAR: ALL_CURRENCIES.ZAR,
};

export const AllCurrencyCodesSchema = z.enum(
  Object.keys(ALL_CURRENCIES) as [keyof typeof ALL_CURRENCIES],
);

export const SupportedCurrencyCodesSchema = z.enum(
  Object.keys(SUPPORTED_CURRENCIES) as [keyof typeof SUPPORTED_CURRENCIES],
);

export type AllCurrencyCodes = z.infer<typeof AllCurrencyCodesSchema>;
export type SupportedCurrencyCodes = z.infer<
  typeof SupportedCurrencyCodesSchema
>;
